module.exports = __webpack_public_path__ + "vu.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/vu.svg
// module id = 886
// module chunks = 0